import { QueryCache, QueryClient } from "@tanstack/react-query";

import { normaliseError } from "../lib/apiError";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      // Clinicians tab-switch constantly; refetching every time is noise and
      // extra load, not freshness.
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        const normalised = normaliseError(error);
        // Never retry a 4xx. The response interceptor already owns the
        // 401 -> refresh -> retry path, and a second retry layer stacked on
        // top of it multiplies refresh attempts into the delete-on-use
        // rotation that signs users out.
        if (normalised.status >= 400 && normalised.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: { retry: false },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      console.error("[query]", query.queryKey, normaliseError(error));
    },
  }),
});
